import { DatePicker, Layout } from 'antd'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Color } from '../../Common/Color'
import SlotFilter from './SlotFilter'
import SlotsTab from './SlotsTab'
import GlobalContext from '../GlobalContext'
import dayjs from 'dayjs'

export default function SlotsPage () {
  const { slots, slotsDate, setSlotsDate, updateSlots, getSlots } = useContext(GlobalContext)
  const [filter, setFilter] = useState({ name: '', box: '', phone: '', assigned_short_name: '' })
  const [_, setTime] = useState(Date.now())

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000)
    setSlotsDate(dayjs())
    return () => {
      clearInterval(interval)
    }
  }, [])

  useEffect(() => {
    getSlots(slotsDate)
  }, [slotsDate])

  const update = (value) => {
    setSlotsDate(value)
  }

  const onChangeFilter = (filter) => {
    setFilter(filter)
  }

  const filteredSlots = slots.filter((slot) => {
    const assignedShortName = slot.assigned_short_name ? slot.assigned_short_name.toLowerCase() : ''
    return dayjs(slot.begin_date).format('YYYY-MM-DD') === slotsDate.format('YYYY-MM-DD') &&
      slot.box.name.toLowerCase().includes(filter.box.toLowerCase()) &&
      slot.name.toLowerCase().includes(filter.name.toLowerCase()) &&
      slot.phone.includes(filter.phone) &&
      assignedShortName.includes(filter.assigned_short_name.toLowerCase())
  })

  return (
    <Layout>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{filteredSlots.length}</b> {t('Admin.SlotsPage.title')}</div>
          <SlotFilter filter={filter} onChangeFilter={onChangeFilter} />
        </div>
      </Layout>
      <Layout style={{ flexDirection: 'row', display: 'flex', margin: 'auto', width: '150px' }}>
        <LeftOutlined onClick={() => setSlotsDate(slotsDate.add(-1, 'day'))} className='hoverable' style={{ cursor: 'pointer', '--hover-color': Color.red }} />
        <DatePicker value={slotsDate} onChange={update} format={'DD/MM/YYYY'} allowClear={false} />
        <RightOutlined onClick={() => setSlotsDate(slotsDate.add(1, 'day'))} className='hoverable' style={{ cursor: 'pointer', '--hover-color': Color.red }} />
      </Layout>
      <SlotsTab slots={filteredSlots} updateSlots={updateSlots} setLoading={() => {}} />
    </Layout>
  )
}
